import { render, staticRenderFns } from "./coaches_dashboard.vue?vue&type=template&id=f38c0712&scoped=true"
import script from "./coaches_dashboard.vue?vue&type=script&lang=js"
export * from "./coaches_dashboard.vue?vue&type=script&lang=js"
import style0 from "./coaches_dashboard.vue?vue&type=style&index=0&id=f38c0712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38c0712",
  null
  
)

export default component.exports